"use client";
import Plot from "react-plotly.js";
import classes from "./FinalAssesmentAttemp.module.css";
import { useEffect, useState } from "react";
import { msToTime } from "../../utils/time";
import {
  chart_finalAssessment,
  stat_getAvgTime_finalAssessment,
} from "../../connections";
import FinalAssessmentIcon from "./FinalAssessmentIcon";

export default function AssessmentDashboard() {
  const [finalAssessmentData, setFinalAssessment] = useState("");
  const [finalAssessmentAvgScore, setFinalAssessmentAvg] = useState("0");
  const [total_attemps, setTotalAttempts] = useState(0);
  const [approved_attemps, setApprovedAttempts] = useState(0);
  const [enabled, setEnabled] = useState(false);
  const [showLegend, setShowLegend] = useState(true);

  const barChartLayout = {
    yaxis: {
      range: [0, Math.max(total_attemps,approved_attemps)],
      tickvals: [20, 40, 60, 80, 100, Math.max(total_attemps,approved_attemps)],
      ticktext: ["20", "40", "60", "80", "100"],
      showgrid: true,
      gridcolor: "#f0f0f0",
      tickfont: { size: 14, color: "#8287A1" },
      zeroline: true,
      zerolinecolor: "#8287A1",
      side: "right" as const,
    },
    xaxis: {
      showticklabels: true,
      automargin: true,
      tickfont: { size: 14, color: "#8287A1" },
    },
    margin: {
      l: 0, 
      r: 30,
      t: 10,
      b: 0,
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
    showlegend: showLegend,
    legend: {
      x: -1.4,
      y: 1,
      font: {
        size: 14,
        weight: 500,
        color: "#8287A1",
      },
    },
    bargap: 0.05,
    bargroupgap: 0.0,
    barcornerradius: 5,
  };

  const config = {
    displayModeBar: false,
    responsive: true,
    editable: false,
    staticPlot: true,
  };
  useEffect(() => {
    const getFinalAssesmentData = async () => {
      const data = await stat_getAvgTime_finalAssessment();
      const data2 = await chart_finalAssessment();
      setEnabled(data.enabled);
      setFinalAssessment(
        data.data
          ? msToTime(data.data?.[0]?.average_final_assessment_time)
          : "00:00:00"
      );
      setFinalAssessmentAvg(data2.data[0].avg_score ?? 0);
      setTotalAttempts(data2.data[0].total_attemps ?? 0);
      setApprovedAttempts(data2.data[0].approved_attemps ?? 0);
    };
    getFinalAssesmentData();
    const handleResize = () => {
      if ((window.innerWidth < 1670 && window.innerWidth > 1024) || window.innerWidth < 780 ) {
        setShowLegend(false);
      } else {
        setShowLegend(true);
      }
    };
    handleResize();
  }, [approved_attemps, total_attemps]);
  
  return enabled ? (
    <div className={classes.dashboardContainer}>
      <h2 className={classes.dashboardTitle}>
        How did the learner perform on the Final Assessment?
      </h2>

      <div className={classes.dashboardGrid}>
        <div className={classes.scoreCard}>
          <div className={classes.scoreContent}>
            <div className={classes.scoreSection}>
              <span className={classes.scoreValue}>
                {finalAssessmentAvgScore}
              </span>
              <p className={classes.scoreLabel}>
                Average Score of
                <br />
                Final Assessment
              </p>
            </div>

            <div className={classes.timeSection}>
              <p className={classes.timeTitle}>Average Time to Completion</p>
              <div className={classes.timeContent}>
                <div className={classes.iconCircle}>
                  <FinalAssessmentIcon/>
                </div>
                <div>
                  <p className={classes.assessmentLabel}>Final Assessment</p>
                  <p className={classes.timeValue}>
                    {finalAssessmentData ?? "00:00:00"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 className={classes.chartTitle}>Final Assessment Attempts</h3>
          <div className={classes.chartContainer}>
            <Plot
              data={[
                {
                  x: ["Total"],
                  y: [total_attemps],
                  type: "bar" as const,
                  name: "Total Attempts",
                  marker: { color: "#0A6E7A" },
                  width: 0.5,
                  showlegend: true,
                },
                {
                  x: ["Passing"],
                  y: [approved_attemps],
                  type: "bar" as const,
                  name: "Passing Attempts",
                  marker: { color: "#26BCD7" },
                  width: 0.5,
                  showlegend: true,
                },
              ]}
              layout={barChartLayout}
              config={config}
              style={{ height: "100%" }}
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
